import withRouter from "hoc/withRouter";
import { useGetAIAgent } from "hooks/useGetAIAgent";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Button, CircularProgress, IconButton, TextField, Tooltip } from "@mui/material";
import AgentsService from "services/admin/AgentsService";
import { toast } from "react-toastify";
import _ from "lodash";
import { FaQuestionCircle } from "react-icons/fa";
import PageGuide from "components/PageGuide/PageGuide";

const AgentPrompts = ({
  router: {
    params: { id },
  },
}: any) => {
  const { data: agent, isLoading, error } = useGetAIAgent(id);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { isValid },
    reset,
  } = useForm({
    defaultValues: {
      prompt: _.get(agent, "prompt", ""),
    },
    mode: "onChange",
  });

  useEffect(() => {
    reset({
      prompt: _.get(agent, "prompt", ""),
    });
  }, [agent]);

  const onSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await AgentsService.put(id, {
        prompt: data.prompt,
      });
      toast.success("Промтинг сохранен успешно!");
    } catch (error) {
      toast.error("Ошибка при сохранении промтинга!");
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <h3 className="mb-4">
        Промтинг
        <Tooltip title="Промтинг — это «мозг» агента: он задаёт роль, ограничения, формат ответов, доступные действия (function calling), этикет, язык и примеры. Чем яснее и конкретнее — тем предсказуемее поведение модели.">
          <IconButton>
            <FaQuestionCircle size={14} />
          </IconButton>
        </Tooltip>
      </h3>
      <PageGuide id="agent-prompts" title="Что написать в промпте">
        <p className="mb-2">Промпт — это инструкция для агента. Пишите как новому сотруднику:</p>
        <ul className="list-disc pl-5 mb-2">
          <li><b>Кто он:</b> «Ты — менеджер компании N, отвечаешь клиентам в Instagram и WhatsApp».</li>
          <li><b>О компании:</b> чем занимаетесь, цены, адрес, график, доставка, способы оплаты.</li>
          <li><b>Цель:</b> например, узнать имя и телефон клиента и передать заявку менеджеру.</li>
          <li><b>Ограничения:</b> «не выдумывай цены», «не обещай скидки», «отвечай коротко».</li>
          <li><b>Примеры:</b> 2–3 частых вопроса клиентов и правильные ответы.</li>
        </ul>
        <p>
          Длинные прайсы и FAQ удобнее загрузить в «Базу знаний» — агент найдёт там нужное сам. После
          изменений проверьте агента в «Тестовой среде».
        </p>
      </PageGuide>
      <p className="mb-8 text-sm text-gray-500"></p>
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
        <div className="mb-8">
          <TextField
            required
            multiline
            minRows={15}
            maxRows={18}
            label="Инструкция"
            {...register("prompt", { required: true })}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
            sx={{
              width: "100%", // Adjust width as needed
              "& .MuiInputBase-inputMultiline": {
                resize: "vertical", // Enables vertical resizing
              },
            }}
          />
        </div>
        <Button
          variant="contained"
          color="primary"
          type="submit"
          disabled={!isValid || isSubmitting}
        >
          {isSubmitting ? <CircularProgress size={20} /> : "Сохранить"}
        </Button>
        {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
      </form>
    </div>
  );
};

export default withRouter(AgentPrompts);
